import { apiClient, type PageData } from './client'
import type { ServiceType, ServiceTypeSavePayload } from '@/types/service-record'

export const serviceTypesApi = {
  list: async (params?: { keyword?: string; page?: number; page_size?: number }): Promise<PageData<ServiceType>> => {
    const searchParams = new URLSearchParams()
    if (params?.keyword) searchParams.set('keyword', params.keyword)
    if (params?.page) searchParams.set('page', String(params.page))
    if (params?.page_size) searchParams.set('page_size', String(params.page_size))
    const qs = searchParams.toString()
    const response = await apiClient.get<PageData<ServiceType>>(qs ? `/service-types?${qs}` : '/service-types')
    return response.data
  },

  options: async (): Promise<ServiceType[]> => {
    const response = await apiClient.get<ServiceType[]>('/service-types/options')
    return response.data
  },

  create: async (data: ServiceTypeSavePayload): Promise<ServiceType> => {
    const response = await apiClient.post<ServiceType>('/service-types', data)
    return response.data
  },

  update: async (id: number, data: ServiceTypeSavePayload): Promise<ServiceType> => {
    const response = await apiClient.put<ServiceType>(`/service-types/${id}`, data)
    return response.data
  },

  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`/service-types/${id}`)
  },

  updateStatus: async (id: number, enabled: boolean): Promise<void> => {
    await apiClient.put(`/service-types/${id}/status`, { enabled })
  },

  reorder: async (ids: number[]): Promise<void> => {
    await apiClient.post('/service-types/reorder', { ids })
  },
}
